import { useState } from 'react'
import { Plus, X } from 'lucide-react'
import { createPerson } from '../lib/api'

const EMPTY_FORM = {
  first_name: '',
  last_name: '',
  nickname: '',
  email: '',
  phone: '',
  city: '',
  maiden_name: '',
  old_city: '',
  school: '',
  employer: '',
  association: '',
  year_hint: '',
  notes: '',
}

export default function AddPersonForm({ onAdded }) {
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [form, setForm] = useState(EMPTY_FORM)

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }))

  const submit = async () => {
    if (!form.first_name.trim() || !form.last_name.trim()) return
    setLoading(true)
    setError('')
    try {
      await createPerson(form)
      setForm(EMPTY_FORM)
      setOpen(false)
      onAdded?.()
    } catch (e) {
      setError(e.message)
    } finally {
      setLoading(false)
    }
  }

  if (!open) {
    return (
      <button className="btn-add" onClick={() => setOpen(true)}>
        <Plus size={18} strokeWidth={1.5} /> Person hinzufügen
      </button>
    )
  }

  return (
    <div className="form-card">
      <div className="form-grid">
        <div className="form-group">
          <label className="form-label">Vorname *</label>
          <input className="form-input" placeholder="z.B. Stefan"
            value={form.first_name} onChange={e => set('first_name', e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Nachname *</label>
          <input className="form-input" placeholder="z.B. Müller"
            value={form.last_name} onChange={e => set('last_name', e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Spitzname</label>
          <input className="form-input" placeholder="z.B. Steff"
            value={form.nickname} onChange={e => set('nickname', e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">E-Mail</label>
          <input className="form-input" type="email" placeholder="z.B. stefan@web.de"
            value={form.email} onChange={e => set('email', e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Telefon</label>
          <input className="form-input" placeholder="z.B. 0176..."
            value={form.phone} onChange={e => set('phone', e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Stadt</label>
          <input className="form-input" placeholder="z.B. Bremen"
            value={form.city} onChange={e => set('city', e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Früherer Name</label>
          <input className="form-input" placeholder="z.B. Geburtsname"
            value={form.maiden_name} onChange={e => set('maiden_name', e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Früherer Ort</label>
          <input className="form-input" placeholder="z.B. alte Heimatstadt"
            value={form.old_city} onChange={e => set('old_city', e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Schule</label>
          <input className="form-input" placeholder="z.B. Gymnasium Nord"
            value={form.school} onChange={e => set('school', e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Arbeitgeber</label>
          <input className="form-input" placeholder="z.B. alte Firma"
            value={form.employer} onChange={e => set('employer', e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Verein/Event</label>
          <input className="form-input" placeholder="z.B. Sportverein, Abi-Party"
            value={form.association} onChange={e => set('association', e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Jahrgang/Jahr</label>
          <input className="form-input" placeholder="z.B. 1995"
            value={form.year_hint} onChange={e => set('year_hint', e.target.value)} />
        </div>
        <div className="form-group wide">
          <label className="form-label">Notizen</label>
          <textarea className="form-textarea"
            placeholder="z.B. Klasse 10b, Jahrgang '95. Spielte beim SV Werder..."
            value={form.notes} onChange={e => set('notes', e.target.value)} />
        </div>
      </div>
      {error && <div className="notice notice-error form-error">{error}</div>}
      <div className="form-actions">
        <button className="btn btn-ghost" onClick={() => setOpen(false)}>
          <X size={14} /> Abbrechen
        </button>
        <button className="btn btn-primary" onClick={submit} disabled={loading}>
          {loading ? <span className="spinner" /> : <Plus size={14} />}
          Speichern
        </button>
      </div>
    </div>
  )
}
